module.exports = __webpack_public_path__ + "img/vehicle_7.f0af9d85.svg";